<p-dialog
  [dismissableMask]="true"
  [(visible)]="visible"
  [style]="{ width: '30vw' }"
  [modal]="true"
  position="center"
  [baseZIndex]="9999999"
  (onShow)="handleShow()"
  (onHide)="handleHide()"
>
  <ng-template pTemplate="header">
    <h4>Export File</h4>
  </ng-template>
  <div class="p-fluid">
    <div class="p-field">
      <label for="export-filename">File name</label>
      <input
        #filenameInput
        id="export-filename"
        type="text"
        pInputText
        [(ngModel)]="filename"
        (keydown.enter)="handleSave()"
      />
    </div>
  </div>
  <ng-template pTemplate="footer">
    <p-button
      pRipple
      icon="pi pi-times"
      (click)="handleCancel()"
      label="Cancel"
      styleClass="p-button-raised p-button-secondary p-button-text"
    ></p-button>
    <p-button
      [disabled]="isSaveDisabled"
      pRipple
      icon="pi pi-check"
      (click)="handleSave()"
      label="Save"
      styleClass="p-button-primary"
    ></p-button>
  </ng-template>
</p-dialog>
